<template>
  <div :class="containerClass">
    <div class="d-felx" :class="topTitleClass">
      <label v-if="topTitle != ''" class="d-inline">{{ topTitle }}</label>
      <span v-if="required" class="text-danger mx-1">*</span>
    </div>
    <div :class="inputThem">
      <multi-select
        v-if="!disabled"
        v-model="inputdata.value"
        class="order-2 pt-0 pb-0"
        :class="!validated ? 'isNotValid' : ''"
        :options="options"
        :searchable="searchable"
        :placeholder="placeHolder"
        @select="this.$emit('update:inputValue', inputdata.value)"
        @deselect="this.$emit('update:inputValue', inputdata.value)"
        @change="multiSelectChanged"
        @search-change="searchChange"
        :clearOnSearch="true"
        :allowEmpty="false"
        :clearOnSelect="true"
        label="label"
        valueProp="id"
        :canClear="canClear"
        :mode="mode"
        :loading="loading"
        :custom-label="labelWithCity"
        :noOptionsText="noOptionsTextt"
        noResultsText="هیچ نتیجه ای یافت نشد"
        :canDeselect="canDeselect"
      />
      <input-with-message
        ref="inputControl"
        v-if="disabled"
        :disableInput="true"
        containerClass="col-12 m-auto "
        topTitle=""
        :inputThem="inputThem"
        inputType="text"
        :showMessage="false"
        :inputValue="disabled ? getValueOfDisabled() : ''"
      />
      <div class="errorSize" :class="errorClass">
        <span v-if="!validated">{{ errorText }}</span>
      </div>
    </div>
  </div>
</template>
<script>
import MultiSelect from '@vueform/multiselect';
import InputWithMessage from '../inputWithMessage/InputWithMessage.vue';
export default {
  components: {
    MultiSelect,
    InputWithMessage,
  },
  props: {
    topTitleClass: {
      type: String,
      required: false,
      default: '',
    },
    errorText: {
      type: String,
      required: false,
      default: '',
    },
    errorClass: {
      type: String,
      required: false,
      default: 'text-danger',
    },
    loading: {
      type: Boolean,
      required: false,
      default: false,
    },
    canClear: {
      type: Boolean,
      required: false,
      default: false,
    },
    canDeselect: {
      type: Boolean,
      required: false,
      default: false,
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
    placeHolder: {
      type: String,
      require: false,
      default: '',
    },
    required: {
      type: Boolean,
      required: false,
      default: false,
    },
    iconSpin: {
      type: Boolean,
      default: false,
      required: false,
    },
    iconName: {
      type: [String, Array],
      require: false,
    },
    inputThem: {
      type: String,
      required: false,
      default: 'whiteThem',
    },
    options: {
      //provide array of options to show users
      type: Array,
      required: true,
    },
    inputValue: {
      //provide array of default value for MultiSelect
      type: [Array, String, Number],
      required: false,
    },
    topTitle: {
      type: String,
      required: false,
      default: 'انتخاب کنید :',
    },
    containerClass: {
      type: String,
      required: false,
      default: '',
    },
    defaultValue: {
      type: [],
      required: false,
    },
    mode: {
      type: String,
      required: false,
      default: 'tags',
    },
    hasSelectableAll: {
      type: Boolean,
      required: false,
      default: false,
    },
    searchable: {
      type: Boolean,
      require: false,
      default: true,
    },
    noOptionsTextt: {
      type: String,
      required: false,
      default: '',
    },
    customLabelFunc: {
      type: Function,
    },
  },
  data() {
    return {
      validated: true,
      inputdata: {
        value: [],
        options: null,
        // mode: 'tags',
        // searchable: true,
        // noOptionsText: 'هیچ نتیجه برای انتخاب نیست',
        // noResultsText: 'هیچ نتیجه ای پیدا نشد',
        // clearOnSelect: false,
        // clearOnSearch: false,
      },
    };
  },
  watch: {
    options: function () {
      this.inputdata.options = this.options;
      if (this.hasSelectableAll && this.inputdata.options.length > 0)
        this.inputdata.options.splice(0, 0, {
          id: -1,
          label: 'انتخاب تمامی موارد',
        });
    },
    'inputdata.value': function () {
      this.$emit('update:inputValue', this.inputdata.value);
    },
    inputValue: function (newValue, oldValue) {
      this.inputdata.value = this.inputValue;
      if (this.mode == 'single') return;
      var difference = oldValue.filter((x) => newValue.indexOf(x) === -1);
      if (difference.length > 0) {
        if (
          difference[0] == -1 ||
          difference.length == this.inputdata.options.length
        )
          return;
        this.$emit('item-changed', difference[0], 'deleted');
        return;
      }
      difference = newValue.filter((x) => oldValue.indexOf(x) === -1);
      if (difference.length > 0) {
        //اگر همه ی موارد انتخاب شده بود ↓
        if (difference[0] == '-1') {
          //اگر تعداد انتخابی با تعداد موجود یکی شد یعنی باید کل مجموعه انتخابی ها پاک شود ↓
          if (this.inputdata.value.length == this.inputdata.options.length) {
            //لیست موارد انتخابی خالی میشود ↓
            this.inputdata.value = [];
            //به بیرون اطلاع میدهد که تمامی موارد حذف شده است
            this.$emit(
              'item-changed',
              this.inputdata.options.map((m) => m.id).filter((f) => f != -1),
              'deletedAll'
            );
          } //در غیر اینصورت کلیه ی آیتم های موجود به صورت موارد انتخابی اضافه گردد ↓
          else {
            this.inputdata.value = this.inputdata.options
              .map((m) => m.id)
              .filter((f) => f != -1);
            //آیتم انتخاب شده باید برابر با شناسه تمامی موارد اضافه شده باشد اگر خط پایین نباشد مقدار منفی یک پاس داده میشود
            this.$emit('update:inputValue', this.inputdata.value);
            //با استفاده از رویداد تمامی مقادیری که اضافه میشوند رو اطلاع میدهد ↓
            this.$emit('item-changed', this.inputdata.value, 'addedAll');
          }
        } // اگر یک مورد انتخاب شده بود آن یک مورد توسط رویداد اطلاع رسانی شود ↓
        else {
          this.$emit('item-changed', difference[0], 'added');
        }
        return;
      }
    },
  },
  methods: {
    labelWithCity({ label, city }) {
      return `${label} — [${city}]`;
    },
    multiSelectChanged(value) {
      this.$emit('update:inputValue', value);
      this.$emit('multiSelectChanged', value);
      this.validated = true;
    },
    searchChange(value) {
      this.$emit('searchChange', value);
      this.validated = true;
    },
    getValueOfDisabled() {
      if (this.$props.inputValue == null) return '';
      let selectedValue;
      if (this.mode == 'single') {
        selectedValue = this.$props.options.find((element) => {
          return element.id == this.$props.inputValue;
        });
        if (selectedValue) return selectedValue.label;
        else return '';
      } else {
        let that = this;
        selectedValue = '';
        /* eslint-disable */
        if (that.$props.inputValue.length > 0) {
          for (let index = 0; index < that.$props.inputValue.length; index++) {
            selectedValue += that.$props.options.find((element) => {
              return element.id == that.$props.inputValue[index];
            })?.label;
            if (index != that.$props.inputValue.length - 1) {
              // if not last item
              selectedValue += ',  ';
            }
          }
          return selectedValue;
        }
      }
    },
    showErrorMessage() {
      this.validated = false;
    },
    hideErrorMessage() {
      this.validated = true;
    },
  },
  mounted() {
    if (this.options) {
      this.inputdata.options = this.options;
      if (this.hasSelectableAll && this.inputdata.options.length > 0)
        this.inputdata.options.splice(0, 0, {
          id: -1,
          label: 'انتخاب تمامی موارد',
        });
    } else {
      throw 'fill options property';
    }
    if (this.inputValue) {
      this.inputdata.value = this.inputValue;
    }
    this.inputdata.mode = this.mode;
  },
};
</script>
<style src="@vueform/multiselect/themes/default.css"></style>
<style>
.multiselect.is-active {
  border-color: rgba(87, 79, 236, 0.5) !important;
  box-shadow: 0 0 0 0.25rem rgba(87, 79, 236, 0.25) !important;
}
.multiselect-option.is-selected {
  background: rgba(87, 79, 236, 0.5) !important;
  color: var(--ms-option-color-pointed, #1f2937) !important;
}
/* .multiselect-option.is-selected {
  background:  #1e90ff !important;
  color: var(--ms-option-color-pointed, #1f2937) !important;
} */
.multiselect-single-label {
  right: 5px !important;
  max-width: 85%;
}
.multiselect-tag {
  padding-right: 24px !important;
  background: #8d9291;
  margin-bottom: 0px;
  white-space: inherit;
}
.multiselect-dropdown {
  box-shadow: 2px 3px 9px 0px #cecece;
}
.multiselect-tags {
  margin-top: 0px;
}
.multiselect {
  padding: 5px;
}
.is-open {
  box-shadow: none !important;
}
/* .multiselect-clear {
  display: none !important;
} */
</style>

<style scoped>
/* Colors : white - #484e5e DarkGray - #4d5361 Gray - #7b7ce6 Purple  */
input.order-2,
textarea.order-2 {
  transition: all 0.5s linear;
  border-radius: 5px 0px 0px 5px !important;
  border-right: unset;
  outline: none !important;
  box-shadow: none;
  border-color: #ccd1df;
}
span.inputSpanTitle {
  border-color: #ccd1df;
  border-radius: 0px 5px 5px 0px !important;
}
/* ----------------- WhiteThem ----------------- */
.whiteThem > span.inputSpanTitle {
  transition: all 0.5s linear;
  background-color: white;
  color: #7b7ce6;
}
.whiteThem:hover > span.inputSpanTitle,
.whiteThem > input:focus ~ span.inputSpanTitle {
  transition: all 0.5s linear;
  background-color: #697183;
  color: rgb(255, 255, 255);
}
/* ----------------- GrayThem ----------------- */
.grayThem > span.inputSpanTitle {
  transition: all 0.5s linear;
  background-color: #697183;
  color: #dadbff;
}
.grayThem:hover > span.inputSpanTitle,
.grayThem > input:focus ~ span.inputSpanTitle,
.grayThem > textarea:focus ~ span.inputSpanTitle {
  transition: all 0.5s linear;
  background-color: #7b7ce6;
  color: white;
}
.grayThem > input:focus,
.grayThem > textarea:focus {
  box-shadow: 0 6px 6px -6px #7b7ce6;
}
/* ----------------- DarkGrayThem ----------------- */
.darkGrayThem > span.inputSpanTitle {
  transition: all 0.5s linear;
  background-color: #484e5e;
  color: #adaeff;
}
.darkGrayThem:hover > span.inputSpanTitle,
.darkGrayThem > input:focus ~ span.inputSpanTitle {
  transition: all 0.5s linear;
  background-color: #697183;
  color: rgb(226, 226, 226);
}
/* ----------------- PurpleThem ----------------- */
.purpleThem > span.inputSpanTitle {
  transition: all 0.5s linear;
  background-color: #7b7ce6;
  color: rgb(255, 255, 255);
}
.purpleThem:hover > span.inputSpanTitle,
.purpleThem > input:focus ~ span.inputSpanTitle {
  transition: all 0.5s linear;
  background-color: white;
  color: #7b7ce6;
}
/* .multiselect-clear {
  display: none !important;
} */
</style>

<style>
.multiselect-placeholder {
  width: 100% !important;
  padding-right: 10px !important;
}
.multiselect-spinner {
  background-color: #6a6cd3;
}
.multiselect-caret {
  -webkit-mask-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3e%3cpath fill='none' stroke='%23343a40' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='M2 5l6 6 6-6'/%3e%3c/svg%3e") !important;
  background-color: #3b4f76 !important;
  width: 0.75rem;
  margin-left: 12px;
  z-index: 9;
}
.multiselect-single-label {
  right: 0px !important;
  padding-right: 1rem;
}
.multiselect-tag {
  padding-right: 5px !important;
}
.errorSize {
  font-size: 0.75em;
}
</style>
